module.exports = "../../tracking-system.JPG";